(function ($) {
    $(document).ready(function () {

        // Submit search form via AJAX.
        const $searchForm = $('form.wp-block-search');
        $searchForm.on('submit', function (e) {
            e.preventDefault();
            const formData = new FormData($(this)[0]);

            $.ajax({
                url: $(this).attr('href'),
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'html'
            }).done(function (data) {
                $('.post-items').html($('.post-items > *', data));
                $('nav.navigation').html($('nav.navigation > *', data));
            });
        });

        // Filter categories via AJAX.
        const $filters = $('.wp-block-categories-list a');
        $filters.on('click', function (e) {
            e.preventDefault();
            $('.wp-block-categories-list li').removeClass('active');
            $(this).parent('li').toggleClass('active');
            $.ajax({
                url: $(this).attr('href'),
                type: 'GET',
                contentType: 'application/json',
                dataType: 'html'
            }).done(function (data) {
                $('.post-items').html($('.post-items > *', data));
                $('nav.navigation').html($('nav.navigation > *', data));
                $(document.body).trigger('filter');
            });
        });

        // Click on category if there is a get params
        const params = new URLSearchParams(window.location.search);
        const category = params.get('category');

        if (category) {
            $('a[href="https://insitu-ergonomie.fr/category/' + category + '/"]').trigger('click');
        }

    });
})(jQuery);
